// ABOUTME: Decides whether a stoppage description is still the auto-generated text.
// ABOUTME: Shared by every stoppage form so they keep or refresh the description identically.
export const isAutoGeneratedDescription = (
  description: string | null | undefined,
  originalTitle: string | null | undefined,
  lastGeneratedDescription: string | null | undefined
): boolean =>
  !!description?.trim() &&
  (description === originalTitle || description === lastGeneratedDescription)
